import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from '@uirouter/angular';
import { JhiEventManager } from 'ng-jhipster';

import { LoginService } from './login.service';
import { StateStorageService } from '../auth/state-storage.service';

@Component({
    selector: 'jhi-login-modal',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class JhiLoginModalComponent implements AfterViewInit {
    authenticationError: boolean;
    password: string;
    rememberMe: boolean;
    username: string;
    credentials: any;

    constructor(
        private eventManager: JhiEventManager,
        private $state: StateService,
        private loginService: LoginService,
        private stateStorageService: StateStorageService,
        private renderer: Renderer2,
        public activeModal: NgbActiveModal
    ) {
        this.credentials = {};
        this.rememberMe = true;
    }

    ngAfterViewInit() {
        this.renderer.selectRootElement('#username').focus();
    }

    cancel() {
        this.credentials = {
            username: null,
            password: null,
            rememberMe: true,
        };
        this.authenticationError = false;
        this.activeModal.dismiss('cancel');
    }

    login() {
        this.loginService
            .login({
                username: this.username,
                password: this.password,
                rememberMe: this.rememberMe,
            })
            .then(() => {
                this.authenticationError = false;
                this.activeModal.dismiss('login success');
                if (
                    this.$state.current.name === 'register' ||
                    this.$state.current.name === 'activate' ||
                    this.$state.current.name === 'finishReset' ||
                    this.$state.current.name === 'requestReset'
                ) {
                    this.$state.go('home');
                }

                this.eventManager.broadcast({
                    name: 'authenticationSuccess',
                    content: 'Sending Authentication Success',
                });

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                let previousState = this.stateStorageService.getPreviousState();
                if (previousState) {
                    this.stateStorageService.resetPreviousState();
                    this.$state.go(previousState.name, previousState.params);
                }
            })
            .catch(() => {
                this.authenticationError = true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/login/login.component.ts